import React from "react";

import {
    Link,
} from "react-router-dom";

const SchoolHouse = () => {

    return (

        <div className="bg-[#F4F1DD] min-h-screen py-10">

            <div className="max-w-6xl mx-auto bg-[#F4F1DD]">

                <h1 className="text-4xl font-bold text-center mb-8 text-[#222]">

                    SCHOOL HOUSES

                </h1>

                <p className="text-lg text-center leading-8 mb-10">

                    Children perform best while competing. To foster a spirit of competition and develop team spirit,
                    the students have been divided into three houses. The houses have been named after our
                    Tricolour- Saffron, White and Green. Students from the three houses compete in various sports, academic and co-curricular activities. Points are awarded to the winning teams. The competitions are divided into three categories. Primary, Middle and Senior.
                    The house scoring the highest number of points is awarded the “Best House Trophy”.

                </p>

                {/* HOUSE TEACHERS */}
                <div className="mt-16 max-w-5xl mx-auto">

                    {/* TITLE */}
                    <div className="text-center mb-10">

                        <h2 className="text-5xl font-serif text-[#2B2B2B]">

                            House Incharge Teachers

                        </h2>

                        <p className="text-3xl mt-4 text-[#333] font-serif">

                            Score Marker - A. Britto

                        </p>

                    </div>


                    {/* TABLE */}
                    <div className="space-y-5">

                        {/* SAFFRON */}
                        <div className="flex flex-col md:flex-row">

                            <Link
                                to="/academics/school-house/saffron"
                                className="
          md:w-[320px]
          w-full
          bg-[#FF6F32]
          hover:bg-[#f15d1f]
          border border-black
          text-center
          text-black
          text-3xl
          font-serif
          py-4
          transition-all duration-300
        "
                            >

                                Saffron House

                            </Link>

                            <div
                                className="
          flex-1
          border border-black
          bg-[#F5F1DE]
          px-6
          py-4
          text-2xl
          font-serif
          flex
          items-center
        "
                            >

                                Ashutosh Kumar Upadhyay |
                                Pratibha Mishra |
                                Deepmala Mishra |
                                Prashant Patel

                            </div>

                        </div>


                        {/* WHITE */}
                        <div className="flex flex-col md:flex-row">

                            <Link
                                to="/academics/school-house/white"
                                className="
          md:w-[320px]
          w-full
          bg-[#F5F5F5]
          hover:bg-gray-300
          border border-black
          text-center
          text-black
          text-3xl
          font-serif
          py-4
          transition-all duration-300
        "
                            >

                                White House

                            </Link>

                            <div
                                className="
          flex-1
          border border-black
          bg-[#F5F1DE]
          px-6
          py-4
          text-2xl
          font-serif
          flex
          items-center
        "
                            >

                                Saleem Javed |
                                Mamta Mishra |
                                Anuradha Singh |
                                Anita Verma

                            </div>

                        </div>


                        {/* GREEN */}
                        <div className="flex flex-col md:flex-row">

                            <Link
                                to="/academics/school-house/green"
                                className="
          md:w-[320px]
          w-full
          bg-[#3CC65B]
          hover:bg-[#2bb84b]
          border border-black
          text-center
          text-black
          text-3xl
          font-serif
          py-4
          transition-all duration-300
        "
                            >

                                Green House

                            </Link>

                            <div
                                className="
          flex-1
          border border-black
          bg-[#F5F1DE]
          px-6
          py-4
          text-2xl
          font-serif
          flex
          items-center
        "
                            >

                                Manoj Kumar Gupta |
                                Ruby Mishra |
                                Babita Singh |
                                Mamta Kumari

                            </div>

                        </div>

                        {/* BLUE */}
                        <div className="flex flex-col md:flex-row">

                            <Link
                                to="/academics/school-house/blue"
                                className="
        md:w-[320px]
        w-full
        bg-[#2563EB]
        hover:bg-[#1D4ED8]
        border border-black
        text-center
        text-white
        text-3xl
        font-serif
        py-4
        transition-all duration-300
      "
                            >
                                Blue House
                            </Link>

                            <div
                                className="
        flex-1
        border border-black
        bg-[#F5F1DE]
        px-6
        py-4
        text-2xl
        font-serif
        flex
        items-center
      "
                            >
                                Akanksha Patel | Ruby Mishra | Sheetal Dubey | Smiriti Pandey | Dhanup Varma
                            </div>

                        </div>

                        {/* MAROON */}
                        <div className="flex flex-col md:flex-row">

                            <Link
                                to="/academics/school-house/maroon"
                                className="
        md:w-[320px]
        w-full
        bg-[#b93b3b]
        hover:bg-[#923636]
        border border-black
        text-center
        text-white
        text-3xl
        font-serif
        py-4
        transition-all duration-300
      "
                            >
                                Maroon House
                            </Link>

                            <div
                                className="
        flex-1
        border border-black
        bg-[#F5F1DE]
        px-6
        py-4
        text-2xl
        font-serif
        flex
        items-center
      "
                            >
                                Ashish Maurya | Sipra Bej | Mamata Mishra | Arya. A. Nair | Shivani Gupta
                            </div>

                        </div>

                        {/* YELLOW */}
                        <div className="flex flex-col md:flex-row">

                            <Link
                                to="/academics/school-house/yellow"
                                className="
        md:w-[320px]
        w-full
        bg-[#f8f661]
        hover:bg-[#f1ef48]
        border border-black
        text-center
        text-black
        text-3xl
        font-serif
        py-4
        transition-all duration-300
      "
                            >
                                Yellow House
                            </Link>

                            <div
                                className="
        flex-1
        border border-black
        bg-[#F5F1DE]
        px-6
        py-4
        text-2xl
        font-serif
        flex
        items-center
      "
                            >
                                Arif Billa Khan | Prashant Patel | Dilip Pandey
                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
};

export default SchoolHouse;